import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SiteSearchDataModel } from 'app/modules/shared/services/site-search.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DeleteLoanService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/deleteLoan').replace(
        '{version}',
        this.version
    );

    constructor(private http: HttpClient) {}

    getPendingLoans(): Observable<any> {
        return this.http.get<SiteSearchDataModel>(this._url + '/getPendingLoans');
    }

    deleteLoan(loanNumber: string): Observable<any> {
        return this.http.put(this._url + '/deleteloan', {
            LoanNumber: loanNumber,
        });
    }
}
